"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class LoaderShelf {
    constructor() {
        this._loading = false;
        mobx_1.makeObservable(this, {
            _loading: mobx_1.observable,
            start: mobx_1.action,
            end: mobx_1.action,
            tryStart: mobx_1.action,
            isLoading: mobx_1.computed,
        });
    }
    tryStart(errorMessage = "Still Loading") {
        if (this.isLoading) {
            throw Error(errorMessage);
        }
        this.start();
    }
    start() {
        this._loading = true;
    }
    end() {
        this._loading = false;
    }
    get isLoading() {
        return this._loading;
    }
}
exports.default = LoaderShelf;
